import get from 'lodash/get';

import { getMultiName } from 'helpers/mappers';

const STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DELETED: 'DELETED',
}

export const BasisType = (item) => {
  const status = get(item, 'status') || '';

  const STATUS_VARIANT = {
    [STATUS.ACTIVE]: 'green',
    [STATUS.INACTIVE]: 'red',
    [STATUS.DELETED]: 'red'
  };

  return {
    id: get(item, 'id') || '',
    name: getMultiName(get(item, 'name')),
    lexId: get(item, 'lex_id') || '',
    status: {
      title: status ? `enum_status_${status}` : '',
      value: status,
      variant: STATUS_VARIANT[status]
    }
  };
};
